import { getWxShareConfig } from 'api/wx'
import { shareStatistics } from 'api/live'

export default {
  data() {
    return {
      shareConfig: null,
      shareLinsters: [
        'onMenuShareTimeline', // 分享到朋友圈
        'onMenuShareAppMessage', // 分享给朋友
        'onMenuShareQQ', // 分享qq
        'onMenuShareWeibo', // 分享到腾讯微博
        'onMenuShareQZone' // 分享到qq空间
      ]
    }
  },
  methods: {
    handleWxShare() {
      const { shareTitle, shareContent, shareUrl, shareCover } = this.shareConfig
      getWxShareConfig().then(res => {
        if (res.code === 0) {
          const _this = this
          const { appId, timestamp, nonceStr, signature } = res.data
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: [...this.shareLinsters] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(() => {
            wx.onMenuShareTimeline({
              title: shareTitle,
              desc: shareContent,
              link: shareUrl,
              imgUrl: shareCover,
              success: function () {
                // 用户点击了分享后执行的回调函数
                _this.handleShareStatistics()
              }
            })
            wx.onMenuShareAppMessage({
              title: shareTitle,
              desc: shareContent,
              link: shareUrl,
              imgUrl: shareCover,
              success: function () {
                // 用户点击了分享后执行的回调函数
                _this.handleShareStatistics()
              }
            })
            wx.onMenuShareQQ({
              title: shareTitle,
              desc: shareContent,
              link: shareUrl,
              imgUrl: shareCover,
              success: function () {
                // 用户点击了分享后执行的回调函数
                _this.handleShareStatistics()
              }
            })
            wx.onMenuShareWeibo({
              title: shareTitle,
              desc: shareContent,
              link: shareUrl,
              imgUrl: shareCover,
              success: function () {
                // 用户点击了分享后执行的回调函数
                _this.handleShareStatistics()
              }
            })
            wx.onMenuShareQZone({
              title: shareTitle,
              desc: shareContent,
              link: shareUrl,
              imgUrl: shareCover,
              success: function () {
                // 用户点击了分享后执行的回调函数
                _this.handleShareStatistics()
              }
            })
          })
        }
      })
    },
    handleShareStatistics() {
      shareStatistics(this.statistics).then(res => {
        if (+res.code === 0) {
          console.log('统计成功')
        }
      })
    }
  }
}
